import { Box, ButtonProps } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import MobileIconButton from 'components/MobileIconButton/MobileIconButton'

const BUTTON_DELETE_TEXT = 'button.delete'
const SELECT_TEXT = 'common.item_selected'
const SELECT_TEXT_SHORT = 'common.item_selected_short'
interface DeleteSelectedButtonProps extends ButtonProps {
    handleOnDelete: Function
    selectedCount: number
    deleteButtonText?: string
    disabled?: boolean
}

function DeleteSelectedButton({
    handleOnDelete,
    selectedCount,
    deleteButtonText = BUTTON_DELETE_TEXT,
    disabled,
    ...buttonProps
}: DeleteSelectedButtonProps) {
    const { t } = useTranslation()
    const handleClick = () => {
        handleOnDelete()
    }
    const { isMobile } = useScreenSize()
    return (
        <Box>
            <MobileIconButton
                startIcon={<Delete />}
                disableElevation
                {...buttonProps}
                disabled={disabled || selectedCount === 0}
                onClick={handleClick}
            >
                {t(deleteButtonText, {
                    count: selectedCount,
                })}
            </MobileIconButton>
            <Box pl={2} display="inline">
                <span>
                    {selectedCount > 0
                        ? t(isMobile ? SELECT_TEXT_SHORT : SELECT_TEXT, {
                              count: selectedCount,
                          })
                        : ''}
                </span>
            </Box>
        </Box>
    )
}

export default DeleteSelectedButton
